import { useEffect, useState } from 'react';

import { Capacitor, type PluginListenerHandle } from '@capacitor/core';

export const useKeyboardShown = () => {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    let keyboardDidShowListener: PluginListenerHandle;
    let keyboardDidHideListener: PluginListenerHandle;

    if (Capacitor.isPluginAvailable('Keyboard')) {
      (async () => {
        const { Keyboard } = await import('@capacitor/keyboard');
        keyboardDidShowListener = await Keyboard?.addListener('keyboardDidShow', (_info) => {
          setShown(true);
        });

        keyboardDidHideListener = await Keyboard?.addListener('keyboardDidHide', () => {
          setShown(false);
        });
      })();
    }

    return () => {
      keyboardDidShowListener?.remove();
      keyboardDidHideListener?.remove();
    };
  }, []);

  return shown;
};
